<template>
    <div class="content-hr">
        <hr />
    </div>
</template>

<script setup lang="ts">
import type { ContentHrModel } from '~/models';


const props = defineProps<{model:ContentHrModel}>();

</script>
